export function getSrc(dom) {
  if (!dom) return ''
  if (dom.tagName.toLowerCase() === 'img') {
    return dom.getAttribute('src')
  } else {
    const value =
      dom.getAttribute('data-src') ||
      dom.getAttribute('data-search-gt-src') ||
      ''
    return value
  }
}

export function other() {}
